import React from "react";
import { Button, DialogActions, TextField } from "@mui/material";
import { useFormik } from "formik";
import { validationSchemaOwner } from "./ValidationSchema";
const AddOwner = (props) => {
  const { prevStep, Values, handleSubmit } = props;

  const formik = useFormik({
    initialValues: {
      ownerName: Values.ownerName,
      ownerAddress: Values.ownerAddress,
      ownerEmail: Values.ownerEmail,
      ownerContact: Values.ownerContact,
    },
    validationSchema: validationSchemaOwner,
    onSubmit: (values) => {
      // update Values state with formik values
      for (const key in values) {
        Values[key] = values[key];
      }
      // call handleSubmit function from parent component
      handleSubmit();
    },
  });
  return (
    <>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-1 gap-4 p-2">
            <TextField
              type="text"
              fullWidth
              id="ownerName"
              label="Owner Name"
              value={formik.values.ownerName}
              onChange={formik.handleChange}
              error={
                formik.touched.ownerName && Boolean(formik.errors.ownerName)
              }
              helperText={formik.touched.ownerName && formik.errors.ownerName}
            />
            <TextField
              type="text"
              fullWidth
              id="ownerAddress"
              label="Owner Address"
              value={formik.values.ownerAddress}
              onChange={formik.handleChange}
              error={
                formik.touched.ownerAddress &&
                Boolean(formik.errors.ownerAddress)
              }
              helperText={
                formik.touched.ownerAddress && formik.errors.ownerAddress
              }
            />
            <TextField
              type="text"
              fullWidth
              id="ownerEmail"
              label="Owner Email"
              value={formik.values.ownerEmail}
              onChange={formik.handleChange}
              error={
                formik.touched.ownerEmail && Boolean(formik.errors.ownerEmail)
              }
              helperText={formik.touched.ownerEmail && formik.errors.ownerEmail}
            />
            <TextField
              type="text"
              fullWidth
              id="ownerContact"
              label="Owner Contact"
              value={formik.values.ownerContact}
              onChange={formik.handleChange}
              error={
                formik.touched.ownerContact &&
                Boolean(formik.errors.ownerContact)
              }
              helperText={
                formik.touched.ownerContact && formik.errors.ownerContact
              }
            />
            <DialogActions>
              <div className="flex justify-end gap-2">
                <Button
                  className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
                  type="button"
                  onClick={prevStep}
                >
                  Back
                </Button>
                <Button
                  className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
                  type="submit"
                >
                  Next
                </Button>
              </div>
            </DialogActions>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddOwner;
